import * as React from 'react';
import { observer } from 'mobx-react-lite';
import { Button } from 'antd';
import { ApplicationDefinitionConditionalEditStore } from '../../stores';
import './ConditionsActionsRenderer.less';
import { HasPermission } from '../../../authorization/components/HasPermission';
import { AppPermissions } from '../../../authorization/Permissions';

interface Props {
    store: ApplicationDefinitionConditionalEditStore;
    tabActions?: React.ReactNode;
}

const ConditionsActionsRenderer: React.FC<Props> = ({ store, tabActions }) => {
    return (
        <div className="conditions-actions-renderer">
            {tabActions}
            <HasPermission
                key="application-definition-conditional-export-permission"
                entityId={store.project?.id}
                permissionClaim={AppPermissions.CanEditIotaApplications}
            >
                <Button type="primary" onClick={() => store.setCreateEditConditionDialogVisible(true)}>
                    New Condition
                </Button>
            </HasPermission>
        </div>
    );
};

export default observer(ConditionsActionsRenderer);
